var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.774 8.638a.414.414 0 01-.316-.128L2.371 6.423a.35.35 0 01-.105-.267.377.377 0 01.64-.268l1.868 1.87 4.32-4.32a.363.363 0 01.267-.108c.106 0 .195.036.267.108a.363.363 0 01.109.268.363.363 0 01-.109.267L5.091 8.51a.414.414 0 01-.317.128z"
  })));
}
export default __webpack_public_path__ + "assets/static/media/check_filled.b298aed7.svg";
export { SvgCheckFilled as ReactComponent };